var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.408,
    height: 52.007,
    viewBox: "0 0 58.408 52.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.065,0l4.266,12.8,12.8,4.266-12.8,4.266-4.266,12.8L12.8,21.331,0,17.065,12.8,12.8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13,0l3.25,9.751L26,13l-9.751,3.25L13,26l-3.25-9.751L0,13l9.751-3.25Z",
    transform: "translate(29.254 26.004)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.314,0,9.142,5.485l5.485,1.828L9.142,9.142,7.314,14.627,5.485,9.142,0,7.314,5.485,5.485Z",
    transform: "translate(43.781 2.125)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.7211ee7499b7128234bb14798fe3a0af.svg";
export { ForwardRef as ReactComponent };